export const CONFIRM_EMAIL_STAFF = `mutation ($data: ConfirmEmailStaffInput!){
  confirmEmailStaff(data: $data)
}`
